import { trim } from 'lodash';
import toQuerystring from "../../utils/toQuerystring";

export const buildAdminTemplateListQueryString = (filters, meta) => {
  let queryString = `?orderBy=${filters.orderBy}&`;
  if (filters.type) {
    if (typeof filters.type === 'string') {
        queryString += `type=${filters.type}&`;    
    }
    if (typeof filters.type === 'object') {
        queryString += `${toQuerystring({
          type: filters.type,
        })}&`;    
    }
  }
  if (filters.status && filters.status !== "") {
      queryString += `status=${filters.status}&`;
  }
  if (filters.search && filters.search !== "") {
      queryString += `s=${filters.search}&`;
  }
  if (filters.date && filters.date !== "empty") {
      queryString += `date=${filters.date}&`;
  }
  if (filters.categories && filters.categories.length > 0) {
      queryString += `${toQuerystring({
          categories: filters.categories,
      })}&`;
  }
  if (filters.tags && filters.tags.length > 0) {
      queryString += `${toQuerystring({
          tags: filters.tags,
      })}&`;
  }
  if (filters.styles && filters.styles.length > 0) {
      queryString += `${toQuerystring({
          styles: filters.styles,
      })}&`;
  }
  if (filters.colors && filters.colors.length > 0) {
      queryString += `${toQuerystring({
          colors: filters.colors,
      })}&`;
  }
  if (filters.fileFormats && filters.fileFormats.length > 0) {
      queryString += `${toQuerystring({
          fileFormats: filters.fileFormats,
      })}&`;
  }
  if (filters.aspectRatios && filters.aspectRatios.length > 0) {
      queryString += `${toQuerystring({
          aspectRatios: filters.aspectRatios,
      })}&`;
  }
  if (meta.current_page && meta.current_page > 1) {
      queryString += `page=${meta.current_page}&`;
  }
  return trim(queryString, "&");
};